import http from "../axios/http-common";

class InterfaceSuket {
  getSKJiwa(reg) {
    return http.getData(`/register/${reg}/suket-sehat-jiwa`);
  }

  getSKJiwaById(id) {
    return http.getData(`/suket-sehat-jiwa/${id}`);
  }

  saveSKJiwa(
    reg, rm, unit_id, keterangan, tujuan
  ) {
    return http.postData(`/suket-sehat-jiwa`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan
    });
  }

  editSKJiwa(
    id, reg, rm, unit_id, keterangan, tujuan
  ) {
    return http.putData(`/suket-sehat-jiwa/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan
    });
  }

  getSKNapza(reg) {
    return http.getData(`/register/${reg}/suket-bebas-napza`);
  }

  getSKNapzaById(id) {
    return http.getData(`/suket-bebas-napza/${id}`);
  }

  saveSKNapza(
    reg, rm, unit_id, keterangan, tujuan
  ) {
    return http.postData(`/suket-bebas-napza`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan
    });
  }

  editSKNapza(
    id, reg, rm, unit_id, keterangan, tujuan
  ) {
    return http.putData(`/suket-bebas-napza/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan
    });
  }

  getSKSehat(reg) {
    return http.getData(`/register/${reg}/suket-sehat-jasmani`);
  }

  getSKSehatById(id) {
    return http.getData(`/suket-sehat-jasmani/${id}`);
  }

  saveSKSehat(
    reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
  ) {
    return http.postData(`/suket-sehat-jasmani`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan,
      sistole: sis,
      diastole: dias,
      tb: tb,
      bb: bb,
      gol_darah: darah,
    });
  }

  editSKSehat(
    id, reg, rm, unit_id, keterangan, tujuan, sis, dias, tb, bb, darah
  ) {
    return http.putData(`/suket-sehat-jasmani/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tujuan: tujuan,
      sistole: sis,
      diastole: dias,
      tb: tb,
      bb: bb,
      gol_darah: darah,
    });
  }

  getSKIstirahat(reg) {
    return http.getData(`/register/${reg}/suket-istirahat`);
  }

  getSKIstirahatById(id) {
    return http.getData(`/suket-istirahat/${id}`);
  }

  saveSKIstirahat(
    reg, rm, unit_id, keterangan, awal, akhir
  ) {
    return http.postData(`/suket-istirahat`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tgl_mulai: awal,
      tgl_selesai: akhir
    });
  }

  editSKIstirahat(
    id, reg, rm, unit_id, keterangan, awal, akhir
  ) {
    return http.putData(`/suket-istirahat/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      keterangan: keterangan,
      tgl_mulai: awal,
      tgl_selesai: akhir
    });
  }

  getRiwayatSuket(reg) {
    return http.getData(`/register/${reg}/surat`);
  }
}
export default new InterfaceSuket();
